import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=539c4088&scoped=true&"
import script from "./settings.vue?vue&type=script&lang=ts&"
export * from "./settings.vue?vue&type=script&lang=ts&"
import style0 from "./settings.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./settings.vue?vue&type=style&index=1&id=539c4088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539c4088",
  null
  
)

export default component.exports